import { useEffect, useState } from "react";
import { postAxios } from "../../util/apiCall";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";

export const useBpb = () => {
  const dataAuth = localStorage.getItem("auth");
  const dataUser = JSON.parse(dataAuth);

  const [popUpTambah, setPopUpTambah] = useState(false);
  const [errIsEmpty, setErrIsEmpty] = useState(false);
  const [isCheck, setIsCheck] = useState(false);
  const [satuanLain, setSatuanLain] = useState();
  const [dariBagian, setDariBagian] = useState(dataUser?.bagian || "");
  const [keBagian, setKeBagian] = useState("PURCHASING");
  const [isJasa, setIsJasa] = useState(false);
  const [isBarang, setIsBarang] = useState(false);
  const [produk, setProduk] = useState();
  const [keterangan, setKeterangan] = useState("");
  const [jumlah, setJumlah] = useState();
  const [dateBpb, setDateBpb] = useState(
    moment().utcOffset("+0700").format("YYYY-MM-DD")
  );
  const [dataListNama, setDataListNama] = useState();
  const [dataTempBpb, setDataTempBpb] = useState([]);
  const [satuan, setSatuan] = useState();
  const [listBpb, setListBpb] = useState();
  const [filterBulan, setFilterBulan] = useState(
    moment().utcOffset("+0700").month() + 1
  );
  const [filterTahun, setFilterTahun] = useState(
    moment().utcOffset("+0700").year()
  );

  const [isRefresh, setIsRefresh] = useState(false);

  const [popUpPick, setPopUpPick] = useState(false);
  const [dataPick, setDataPick] = useState();
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getbpb`,
      {
        tim: dataUser.tim,
        id: dataUser.id,
        filterDate: `${filterTahun}-${("0" + filterBulan).slice(-2)}`,
      },
      dataUser.auth,
      setListBpb,
      ""
    );

    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getListNamaBpb`,
      {
        tim: dataUser.tim,
      },
      dataUser.auth,
      setDataListNama,
      ""
    );

    setIsRefresh(false);
  }, [isRefresh, filterBulan, filterTahun]);

  const handleCloseAddBpb = () => {
    setDateBpb(moment().utcOffset("+0700").format("YYYY-MM-DD"));
    setDariBagian();
    setKeBagian();
    setIsCheck(false);
    setIsJasa(false);
    setIsBarang(false);
    setProduk();
    setPopUpTambah(false);
    setKeterangan("");
    setJumlah();
    setDataTempBpb([]);
    setSatuan();
    setSatuanLain();
  };

  const handlePickJenisBpb = (e) => {
    if (e === "barang") {
      setIsJasa(false);
      setIsBarang(true);
    } else if (e === "jasa") {
      setIsJasa(true);
      setIsBarang(false);
    }
  };

  const handleDeleteBarangPick = (id) => {
    let data = [...dataTempBpb];
    data.splice(
      data.findIndex(function (i) {
        return i.id === id;
      }),
      1
    );

    setDataTempBpb(data);
  };

  const handleKirimBpb = () => {
    if (
      dariBagian &&
      keBagian &&
      jumlah &&
      produk &&
      keterangan &&
      (isBarang || isJasa) &&
      (satuan !== "LAINNYA" ? satuan : satuanLain)
    ) {
      setDataTempBpb([
        ...dataTempBpb,
        {
          id: produk.id,
          checklistId: uuidv4(),
          isBeli: true,
          isRealisasi: false,
          item: isCheck ? produk.value : produk,
          jumlah: jumlah,
          satuan: satuan !== "LAINNYA" ? satuan : satuanLain,
          keterangan: keterangan,
          jenis: isBarang ? "Barang" : isJasa ? "Jasa" : "",
        },
      ]);
      setProduk();
      setJumlah();
      setErrIsEmpty(false);
    } else {
      setErrIsEmpty(true);
    }
  };

  const handleSubmitBpb = () => {
    if (dataTempBpb.length > 0) {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/addNewBpb`,
        {
          items: dataTempBpb,
          rencana: "",
          realisasi: "",
          date: moment(dateBpb).utcOffset("+0700").format(),
          dari: dariBagian,
          ke: keBagian,
          id: uuidv4(),
          satuan: satuan,
          isApprove: false,
          isProccess: false,
          requestor: dataUser.name,
          tim: dataUser.tim,
        },
        dataUser.auth,
        "",
        ""
      );
      handleCloseAddBpb();
      setIsRefresh(true);
      setIsDisabled(false);
    }
  };

  const handlePickBpb = (data) => {
    setPopUpPick(true);
    setDataPick(data);
  };

  return {
    popUpTambah,
    setPopUpTambah,
    errIsEmpty,
    isCheck,
    setIsCheck,
    handleCloseAddBpb,
    isBarang,
    isJasa,
    dataListNama,
    satuan,
    satuanLain,
    setSatuanLain,
    keterangan,
    setKeterangan,
    handleKirimBpb,
    dateBpb,
    setDateBpb,
    handlePickJenisBpb,
    setDariBagian,
    dariBagian,
    setKeBagian,
    keBagian,
    produk,
    setProduk,
    jumlah,
    setJumlah,
    setSatuan,
    dataTempBpb,
    handleDeleteBarangPick,
    handleSubmitBpb,
    setFilterBulan,
    filterBulan,
    setFilterTahun,
    filterTahun,
    listBpb,
    handlePickBpb,
    setIsRefresh,
    dataPick,
    popUpPick,
    setPopUpPick,
    isDisabled,
    setIsDisabled,
  };
};
